<template>
	<label :class="classList">
		<input
			v-bind="$attrs"
			:type="type"
			:checked="state"
			:value="true_value"
			class="g-switch-input form-check-input"
			@change="onChange" />
		<span :data-checked="labelOn" :data-unchecked="labelOff" class="g-switch-slider"> </span>
		<input
			v-if="alwaysSendInput === true && state === false"
			v-bind="$attrs"
			:value="false_value"
			hidden />
	</label>
</template>

<script>
	export default {
		name: 'GSwitch',
		inheritAttrs: false,
		props: {
			color: String,
			variant: {
				type: String,
				validator: value => ['', 'outline', 'opposite', '3d'].includes(value),
			},
			size: {
				type: String,
				validator: value => ['', 'lg', 'sm'].includes(value),
			},
			shape: {
				type: String,
				validator: value => ['', 'pill', 'square'].includes(value),
			},
			checked: Boolean,
			labelOn: String,
			labelOff: String,
			type: {
				type: String,
				default: 'checkbox',
				validator: type => ['checkbox', 'radio'].includes(type),
			},
			alwaysSendInput: {
				// Always send the input data even when it's unchecked
				type: Boolean,
				default: true,
			},
			true_value: {
				default: 1,
			},
			false_value: {
				default: 0,
			},
		},
		data() {
			return {
				state: undefined,
			};
		},
		watch: {
			checked: {
				immediate: true,
				handler(val) {
					this.state = val;
				},
			},
		},
		computed: {
			classList() {
				const variant = this.variant ? `-${this.variant}` : '';
				return [
					'g-switch form-check-label',
					{
						[`g-switch-${this.size}`]: this.size,
						[`g-switch-${this.shape}`]: this.shape,
						[`g-switch${variant}-${this.color}`]: this.color,
						'g-switch-label': this.labelOn || this.labelOff,
					},
				];
			},
		},
		methods: {
			onChange(e) {
				this.state = e.target.checked;
				this.$emit('update:checked', e.target.checked, e);
			},
		},
	};
</script>

<style>
	.g-switch-slider {
		position: relative;
		display: block;
		height: inherit;
		cursor: pointer;
		border: 1px solid;
		-webkit-transition: 0.15s ease-out;
		transition: 0.15s ease-out;
		border-radius: 0.25rem;
		background-color: #fff;
		border-color: #d8dbe0;
	}

	.g-switch {
		display: inline-block;
		width: 40px;
		height: 26px;
	}

	.g-switch-input {
		position: absolute;
		z-index: -1;
		opacity: 0;
	}

	.g-switch-slider::before {
		position: absolute;
		top: 2px;
		left: 2px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		width: 20px;
		height: 20px;
		content: '';
		background-color: #fff;
		border: 1px solid #d8dbe0;
		-webkit-transition: 0.15s ease-out;
		transition: 0.15s ease-out;
		border-radius: 0.125rem;
	}

	/** WHEN CHECKED */
	.g-switch-primary .g-switch-input:checked + .g-switch-slider {
		background-color: #321fdb;
		border-color: #2819ae;
	}

	.g-switch-primary .g-switch-input:checked + .g-switch-slider::before {
		border-color: #2819ae;
	}

	.g-switch-input:checked ~ .g-switch-slider::before {
		-webkit-transform: translateX(14px);
		transform: translateX(14px);
	}
</style>
